import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchGameHelp, type IFetchHelpParams } from '../../api/fetchers/help/fetcher';

// Use this action to fetch game-specif and common help files
export const fetchHelpAction = createAsyncThunk('help/fetchHelp', (params: IFetchHelpParams) => fetchGameHelp(params));
